import styled from 'styled-components';

export const Column = styled.div`
  column-width: 280px;
  column-gap: 40px;
  margin: 1rem 0;
`;

export const Item = styled.div`
  break-inside: avoid;

  h3 {
    margin-top: 0;
  }
`;
